import React, { useEffect, useState } from 'react';
import { useEleccions } from 'hooks/3catinfo/useEleccions';
import { useEmitter } from 'hooks/useEmitter';
import GraficBarres from 'components/3catinfo/Eleccions/Grafiques/TipusGrafics/GraficBarres';
import PeuEscrutini from 'components/3catinfo/Eleccions/Grafiques/PeuEscrutini';
import LlegendaEleccions from 'components/3catinfo/Eleccions/Grafiques/LlegendaEleccions';
import MostraMesResultats from 'components/3catinfo/Eleccions/Grafiques/MostraMesResultats';
import LlegendaAnysComparacio from 'components/3catinfo/Eleccions/Grafiques/LlegendaAnysComparacio';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from '../graficEleccions.module.scss';

const Titol = (props) => {
    const { mostraTitol = true, titol, tamany } = props;
    if (!mostraTitol) return <></>;
    const stylesTitol = clsx(styles.titol, tamany === 'petit' && styles.titolEsquerre);
    return (
        <div className={stylesTitol}>
            <h3>{titol}</h3>
        </div>
    );
};

const Grafic = React.memo(
    (props) => {
        const { dataMain, dataSecondary, paramsChart, optionsChart } = props;
        return (
            <GraficBarres
                dataMain={dataMain}
                dataSecondary={dataSecondary}
                paramsChart={paramsChart}
                optionsChart={optionsChart}
                {...props}
            />
        );
    },
    (prevProps, nextProps) => {
        return (
            JSON.stringify(prevProps.dataMain) === JSON.stringify(nextProps.dataMain) &&
            JSON.stringify(prevProps.dataSecondary) === JSON.stringify(nextProps.dataSecondary) &&
            JSON.stringify(prevProps.paramsChart) === JSON.stringify(nextProps.paramsChart) &&
            JSON.stringify(prevProps.optionsChart) === JSON.stringify(nextProps.optionsChart) &&
            prevProps.numColumnsRow === nextProps.numColumnsRow
        );
    }
);

Grafic.displayName = 'Grafic';

const BarresVots = (props) => {
    const {
        emitterId,
        urlDades,
        urlDadesComparador,
        tipusLlegenda,
        estilLlegenda,
        estil,
        fase,
        slug,
        id,
        linkTipusMostraMes,
        mostrarComparativa,
        numColumnsRow,
        className,
        peuMostraCamps = ['electes', 'participacio'],
        intervalRefresh = 0,
        mostraLlegenda = true,
        mostraPeu = true,
        mostraEscrutini = true,
        mostraMesBoto = true,
        limitItems = 0,
        mostrarPartitsSenseDiputats = false,
        tamany = 'petit',
        limitValueCondition = 1,
        limitValueField = 'perc',
        selected,
        tipusEleccions,
        carrec = 'Regidors',
        peuComparadorActiu = false,
        dataTestId
    } = props;

    const tipusCarrec = tipusEleccions === 'municipals' ? carrec : 'Diputats';
    const textMostraMes = props.textMostraMes?.replace('[titol]', props.titol);
    const { dataActual, dataComparador, dataActualFormat, dataComparadorFormat, isDataLoaded, getDades, getSlugEleccions } =
        useEleccions();
    const { onEmitter } = useEmitter();
    const percentatgeEscrutini = dataActual?.datos?.geo?.perc_escrutat;
    const mostraPercentatgeEscrutini =
        mostraEscrutini &&
        percentatgeEscrutini !== undefined &&
        percentatgeEscrutini !== null &&
        percentatgeEscrutini !== '' &&
        Number.isFinite(Number(percentatgeEscrutini));
    const isEmptyDataMain = __isEmpty(dataActualFormat?.labels);
    const isGraficGran = tamany === 'gran';
    const [showSecondaryGraph, setShowSecondaryGraph] = useState(false);

    onEmitter(emitterId, (value) => {
        setShowSecondaryGraph(value);
    });

    useEffect(() => {
        getDades({
            urlDades,
            urlDadesComparador,
            intervalRefresh,
            dataGraphFormatType: 'votsBarres',
            params: {
                mostrarPartitsSenseDiputats,
                fase,
                tamany,
                limit: limitItems,
                limitValueCondition: limitValueCondition
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlDades]);

    const paramsChart = {
        showSecondaryGraph,
        isGraficGran,
        borderRadius: isGraficGran ? 4 : 2,
        mostrarLlegendaX: isGraficGran && (showSecondaryGraph || !isEmptyDataMain),
        drawLineLabelX: isGraficGran,
        datalabelsLlargs: true
    };

    const printTooltip = (value) => {
        const lines = [];
        if (value?.diputats > 0) {
            lines.push(`${value.diputats} ${tipusCarrec.toLowerCase()}`);
        }
        if (value?.percVots) {
            if (value?.percVots > 0) {
                lines.push(`${value.percVots.toFixed(2).replace('.', ',')}% vots`);
            }
        }
        return lines.join('\n');
    };

    const optionsChart = {
        plugins: {
            tooltip: {
                callbacks: {
                    title: () => '',
                    label: (context) => ` ${context.dataset.datalabelsArray[context.dataIndex]}`,
                    footer: (context) => {
                        const { dataset, dataIndex } = context[0];
                        const sourceData = dataset.isPattern ? dataComparadorFormat?.dataAll : dataActualFormat?.dataAll;
                        return printTooltip(sourceData?.[dataIndex]);
                    }
                }
            }
        },
        scales: {
            x: {
                border: {
                    display: !(isEmptyDataMain && isGraficGran && !showSecondaryGraph)
                },
                ticks: {
                    display: isGraficGran && (showSecondaryGraph || !isEmptyDataMain) // labels footer
                }
            }
        }
    };

    if (!isDataLoaded) return <></>;

    const stylesContentGrafic = clsx(
        styles.contentGrafic,
        className,
        estil && styles[estil],
        styles.contentGrafic,
        fase === 'seo' && !showSecondaryGraph && styles.disabled,
        numColumnsRow > 0 && styles['col' + numColumnsRow]
    );
    const stylesCapcalera = clsx(styles.capcalera, !mostraEscrutini && styles.right);

    return (
        <div className={stylesContentGrafic} {...(dataTestId && { 'data-testid': dataTestId })}>
            <div className={styles.grafic}>
                <div className={stylesCapcalera}>
                    <Titol dataActual={dataActual} dataComparador={dataComparador} {...props} />
                    {mostraPercentatgeEscrutini && <div className={styles.escrutini}>Escrutini {percentatgeEscrutini}%</div>}
                    <LlegendaAnysComparacio
                        anyActual={dataActual?.datos?.geo?.year}
                        anyAnterior={dataComparador?.datos?.geo?.year}
                        emitterId={emitterId}
                    />
                </div>
                <Grafic
                    key={`grafic-barres-vots-${id}-${showSecondaryGraph}-${isGraficGran}-${selected}`}
                    dataMain={dataActualFormat}
                    dataSecondary={dataComparadorFormat}
                    optionsChart={optionsChart}
                    paramsChart={paramsChart}
                    {...props}
                />
                {mostraLlegenda && (
                    <LlegendaEleccions
                        dataActual={dataActual?.datos?.geo}
                        dataComparador={dataComparador?.datos?.geo}
                        emitterId={emitterId}
                        tipus={tipusLlegenda}
                        estil={estilLlegenda}
                        mostrarComparativa={mostrarComparativa}
                        mostrarPartitsSenseDiputats={mostrarPartitsSenseDiputats}
                        fase={fase}
                        numColumnsRow={numColumnsRow}
                        limitItems={limitItems}
                        limitValueCondition={limitValueCondition}
                        limitValueField={limitValueField}
                        limitValueStrict={false}
                        tipusEleccions={tipusEleccions}
                    />
                )}
            </div>
            {mostraPeu && (
                <PeuEscrutini
                    data={dataActual?.datos?.geo}
                    dataComparador={dataComparador?.datos?.geo}
                    emitterId={emitterId}
                    peuMostraCamps={peuMostraCamps}
                    peuComparadorActiu={peuComparadorActiu}
                    {...props}
                />
            )}
            {mostraMesBoto && (
                <MostraMesResultats
                    titol={textMostraMes}
                    slug={getSlugEleccions()}
                    slug2={slug}
                    id={id}
                    linkTipus={linkTipusMostraMes}
                />
            )}
        </div>
    );
};

export default BarresVots;
